import { render, staticRenderFns } from "./PollingRecord.vue?vue&type=template&id=815acb54&"
import script from "./PollingRecord.vue?vue&type=script&lang=js&"
export * from "./PollingRecord.vue?vue&type=script&lang=js&"
import style0 from "./PollingRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports